import './utils/wallet/browserPolyfills'
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// import { dologin } from './utils/useWeb3Modal';

import { appKit } from './utils/wallet/appKit.js'
import { storecfg } from './utils/wallet/appkitStore.js'
import { updateTheme, updateButtonVisibility } from './utils/wallet/dom.js'
import { initializeSubscribers } from './utils/wallet/suscribers.js'
// Initialize subscribers
initializeSubscribers(appKit)

// Initial check
updateButtonVisibility(appKit.getIsConnectedState());
// Set initial theme
updateTheme(storecfg.themeState.themeMode)
// Default to Ethereum mainnet for login if not set
if (!localStorage.getItem('cur_chainId')) {
  localStorage.setItem('cur_chainId', '1');
}
// Default authorization token to USDC when the user has not selected one yet.
if (!localStorage.getItem('sys_coin')) {
  localStorage.setItem('sys_coin', 'usdc');
}

import Clipboard from "v-clipboard";
import {
	Overlay,Uploader,Button,DropdownMenu, DropdownItem,
	Tab, Tabs, Empty,
	TextEllipsis,
	Notify,
	ShareSheet,
	closeToast,
	showLoadingToast,
	RollingText,
	Toast,
	Dialog,
	NoticeBar,
	Swipe,
	SwipeItem,
	Icon,
	Progress,
	Field,
	Collapse, CollapseItem,
	Cell,
	RadioGroup,
	Radio,
	PasswordInput,
	NumberKeyboard,
	Popup,
	CellGroup,
	ActionSheet,
	CountDown, Checkbox,
	Loading,
	Picker,
	Grid,
	GridItem
} from "vant";
import 'vant/lib/index.css';

// import vueTouch from "vue-plugin-touch";
import touch from 'vue-directive-touch';
import i18n from './i18n';
import '@/assets/styles/reset.scss';
import { formatRecordTime } from './utils/dateTime';

if (window.innerWidth < 768) {
	require('lib-flexible');
}

const app = createApp(App);
app.config.compilerOptions.isCustomElement = (tag) => {
  return tag === 'appkit-button';
};
app.use(router)
	.use(Toast)
	.use(Overlay)
	.use(Uploader)
	.use(RadioGroup)
	.use(Radio)
	.use(Button)
	.use(DropdownMenu)
	.use(DropdownItem)
	.use(Tab)
	.use(Tabs)
	.use(Empty)
	.use(CountDown)
	.use(Checkbox)
	.use(store)
	.use(i18n)
	.use(ShareSheet)
	.use(closeToast)
	.use(showLoadingToast)
	.use(Clipboard)
	.use(RollingText)
	.use(TextEllipsis)
	.use(Notify)
	.use(Dialog)
	// .use(vueTouch)
	.use(touch)
	.use(Icon)
	.use(Progress)
	.use(Field)
	.use(NoticeBar)
	.use(Swipe)
	.use(PasswordInput)
	.use(NumberKeyboard)
	.use(Popup)
	.use(Picker)
	.use(Grid)
	.use(GridItem)
	.use(Loading)
	.use(ActionSheet)
	.use(Collapse)
	.use(CollapseItem)
	.use(Cell).use(CellGroup)
	.use(SwipeItem);


app.config.globalProperties.utils_moneyMark = function () {
	var coin = localStorage.getItem("sys_coin");
	if(coin && coin=='usdt'){
		return "USDT";
	}else{
		return "USDC";
	}
};
app.config.globalProperties.showcover = false;
app.config.globalProperties.$formatRecordTime = formatRecordTime;

app.mount('#app');
